<div class="circle-big" [ngClass]="[className, small ? 'small' : '']">
  <div class="text" [ngClass]="{'small': smallText}" *ngIf="core.loadingState === 'NONE' && auth.authenticated">
    {{textOverride || (score | number: '1.0-0')}}<div class="small" *ngIf="!small">{{'SECTIONS.COMMON.circle-progress.POINTS' | translate}}</div>
  </div>
  <svg viewBox="0 0 400 400">
    <circle class="bg" cx="200" cy="200" r="159.1549431"></circle>
    <circle class="progress" cx="200" cy="200" r="159.1549431" [class.spin]="!core.components[LoadingComponent.INVENTORY]" [style.strokeDashoffset]="core.components[LoadingComponent.INVENTORY] ? percentage : 0"></circle>
  </svg>
</div>
